import React from 'react';
import { Footer } from '../Layout/Footer';

interface ProfileUpdatePublicShellProps {
  children: React.ReactNode;
}

/**
 * Centered column for profile-update sign-in / status screens.
 * Card and footer share one max-width stack so they cannot lay out side-by-side.
 */
export function ProfileUpdatePublicShell({ children }: ProfileUpdatePublicShellProps) {
  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-[#0a0a0a] px-4 py-8 sm:py-12">
      <div className="mx-auto flex w-full max-w-md min-w-0 flex-col gap-8">
        {children}
        <Footer compact />
      </div>
    </div>
  );
}
